var pe = Object.defineProperty;
var he = (t, e, s) => e in t ? pe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var b = (t, e, s) => (he(t, typeof e != "symbol" ? e + "" : e, s), s);
import "./assets/index.a4db810a.css";
import { defineComponent as j, openBlock as u, createElementBlock as f, createElementVNode as C, Fragment as z, renderList as ne, unref as r, ref as c, computed as p, onMounted as Z, watchEffect as R, onUnmounted as ae, normalizeClass as oe, normalizeStyle as ee, createVNode as ye, createCommentVNode as w, createBlock as L, createTextVNode as ie, toDisplayString as F, resolveDynamicComponent as ge, useAttrs as be } from "vue";
let H = 0;
class xe {
  constructor() {
    b(this, "subscribers");
    b(this, "toasts");
    b(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const s = this.subscribers.indexOf(e);
      this.subscribers.splice(s, 1);
    }));
    b(this, "publish", (e) => {
      this.subscribers.forEach((s) => s(e)), this.toasts = [...this.toasts, e];
    });
    b(this, "dismiss", (e) => (e || this.toasts.forEach((s) => {
      this.subscribers.forEach(
        (a) => a({ id: s.id, dismiss: !0 })
      );
    }), this.subscribers.forEach((s) => s({ id: e, dismiss: !0 })), e));
    b(this, "message", (e, s) => {
      const a = (s == null ? void 0 : s.id) || H++;
      return this.publish({ ...s, id: a, title: e }), a;
    });
    b(this, "error", (e, s) => {
      const a = (s == null ? void 0 : s.id) || H++;
      return this.publish({ ...s, id: a, type: "error", title: e }), a;
    });
    b(this, "success", (e, s) => {
      const a = (s == null ? void 0 : s.id) || H++;
      return this.publish({ ...s, id: a, type: "success", title: e }), a;
    });
    b(this, "promise", (e, s) => {
      const a = (s == null ? void 0 : s.id) || H++;
      return this.publish({ ...s, promise: e, id: a }), a;
    });
    b(this, "custom", (e, s) => {
      const a = (s == null ? void 0 : s.id) || H++;
      this.publish({ ...s, id: a, title: e });
    });
    this.subscribers = [], this.toasts = [];
  }
}
const $ = new xe(), Te = (t, e) => {
  const s = (e == null ? void 0 : e.id) || H++;
  return $.publish({
    title: t,
    ...e,
    id: s
  }), s;
}, we = Te, rt = Object.assign(we, {
  success: $.success,
  error: $.error,
  custom: $.custom,
  message: $.message,
  promise: $.promise,
  dismiss: $.dismiss
}), ke = ["data-visible"], Ce = { className: "sonner-spinner" }, Be = /* @__PURE__ */ j({
  __name: "Loader",
  props: {
    visible: Boolean
  },
  setup(t) {
    const e = Array(12).fill(0);
    return (s, a) => (u(), f("div", {
      className: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [
      C("div", Ce, [
        (u(!0), f(z, null, ne(r(e), (N) => (u(), f("div", {
          key: `spinner-bar-${N}`,
          className: "sonner-loading-bar"
        }))), 128))
      ])
    ], 8, ke));
  }
}), A = (t, e) => {
  const s = t.__vccOpts || t;
  for (const [a, N] of e)
    s[a] = N;
  return s;
}, $e = /* @__PURE__ */ A(Be, [["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/assets/Loader.vue"]]), Ne = {}, De = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, Ie = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  "clip-rule": "evenodd"
}, null, -1), Ee = [
  Ie
];
function Pe(t, e) {
  return u(), f("svg", De, Ee);
}
const Se = /* @__PURE__ */ A(Ne, [["render", Pe], ["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/assets/SuccessIcon.vue"]]), qe = {}, Oe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, _e = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1), He = [
  _e
];
function Re(t, e) {
  return u(), f("svg", Oe, He);
}
const Ae = /* @__PURE__ */ A(qe, [["render", Re], ["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/assets/ErrorIcon.vue"]]), Me = {}, Ue = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Fe = /* @__PURE__ */ C("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1), Le = /* @__PURE__ */ C("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1), ze = [
  Fe,
  Le
];
function Ge(t, e) {
  return u(), f("svg", Ue, ze);
}
const Ve = /* @__PURE__ */ A(Me, [["render", Ge], ["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/assets/CloseIcon.vue"]]), je = ["aria-live", "data-styled", "data-mounted", "data-promise", "data-removed", "data-visible", "data-y-position", "data-x-position", "data-index", "data-front", "data-swiping", "data-type", "data-invert", "data-swipe-out", "data-expanded"], Ke = ["data-disabled"], We = {
  key: 1,
  "data-icon": ""
}, Ye = { "data-content": "" }, Je = { "data-title": "" }, Qe = /* @__PURE__ */ j({
  __name: "Toast",
  props: {
    toast: {
      type: Object,
      required: !0
    },
    toasts: {
      type: Array,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    invert: {
      type: Boolean,
      required: !0
    },
    heights: {
      type: Array,
      required: !0
    },
    setHeights: {
      type: Function,
      required: !0
    },
    removeToast: {
      type: Function,
      required: !0
    },
    position: {
      type: String,
      required: !0
    },
    visibleToasts: {
      type: Number,
      required: !0
    },
    expandByDefault: {
      type: Boolean,
      required: !0
    },
    closeButton: {
      type: Boolean,
      required: !0
    },
    interacting: {
      type: Boolean,
      required: !0
    },
    duration: {
      type: Number,
      required: !1
    },
    descriptionClass: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = t, s = 4e3, a = 14, N = 20, K = 200, m = (o) => Boolean(o.promise), D = c(!1), g = c(!1), B = c(!1), S = c(!1), v = c(null), q = c(0), G = c(0), O = c(null), d = c(null), l = p(() => e.index === 0), h = p(() => e.index + 1 <= e.visibleToasts), x = p(() => e.toast.type), _ = e.toast.className || "", I = e.toast.descriptionClassName || "", E = e.toast.style || {}, M = p(
      () => e.heights.findIndex((o) => o.toastId === e.toast.id) || 0
    ), re = p(
      () => e.toast.duration || e.duration || s
    ), W = c(0), U = c(0), Y = c(re.value), te = c(0), V = c(null), J = p(() => e.position.split("-")), le = p(() => e.heights.reduce((o, i, n) => n >= M.value ? o : o + i.height, 0)), ue = p(() => e.toast.invert || e.invert), Q = p(() => v.value === "loading"), se = p(
      () => {
        var o;
        return (o = v.value) != null ? o : e.toast.type || null;
      }
    ), X = p(() => !m(e.toast) && typeof e.toast.title == "object"), ce = p(() => {
      if (!m(e.toast))
        return null;
      switch (v.value) {
        case "loading":
          return e.toast.loading;
        case "success":
          return typeof e.toast.success == "function" ? O.value : e.toast.success;
        case "error":
          return typeof e.toast.error == "function" ? O.value : e.toast.error;
        default:
          return null;
      }
    });
    Z(() => D.value = !0), R(() => {
      U.value = M.value * a + le.value;
    }), R(() => {
      var o, i;
      if (e.toast && m(e.toast)) {
        const n = e.toast;
        v.value = "loading";
        const T = (y) => {
          y.then((k) => {
            n.success && typeof n.success == "function" && (O.value = n.success(k)), v.value = "success";
          }).catch((k) => {
            n.error && typeof n.error == "function" && (O.value = n.error(k)), v.value = "error";
          });
        };
        e.toast.promise instanceof Promise ? T(e.toast.promise) : typeof e.toast.promise == "function" && T((i = (o = e.toast) == null ? void 0 : o.promise) == null ? void 0 : i.call(o));
      }
    });
    function de() {
      var o, i;
      Q.value || (P(), (i = (o = e.toast).onDismiss) == null || i.call(o, e.toast));
    }
    function P() {
      g.value = !0, q.value = U.value, e.setHeights(
        e.heights.filter((o) => o.toastId !== e.toast.id)
      ), setTimeout(() => {
        e.removeToast(e.toast);
      }, K);
    }
    const ve = (o) => {
      Q || (q.value = U.value, o.target.setPointerCapture(o.pointerId), o.target.tagName !== "BUTTON" && (B.value = !0, V.value = o.clientY));
    }, fe = (o) => {
      var n, T, y, k;
      if (S.value)
        return;
      const i = Number(
        ((n = d.value) == null ? void 0 : n.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0
      );
      if (Math.abs(i) >= N) {
        q.value = U.value, (y = (T = e.toast).onDismiss) == null || y.call(T, e.toast), P(), S.value = !0;
        return;
      }
      (k = d.value) == null || k.style.setProperty("--swipe-amount", "0px"), V.value = null, B.value = !0;
    }, me = (o) => {
      var T, y;
      if (!V.value)
        return;
      const i = o.clientY - V.value;
      if (!(J.value[0] === "top" ? i < 0 : i > 0)) {
        (T = d.value) == null || T.style.setProperty("--swipe-amount", "0px");
        return;
      }
      (y = d.value) == null || y.style.setProperty("--swipe-amount", `${i}px`);
    };
    return R((o) => {
      if (e.toast.promise && v.value === "loading" || e.toast.duration === 1 / 0)
        return;
      let i;
      const n = () => {
        if (te.value < W.value) {
          const y = new Date().getTime() - W.value;
          Y.value = Y.value - y;
        }
        te.value = new Date().getTime();
      }, T = () => {
        W.value = new Date().getTime(), i = setTimeout(() => {
          var y, k;
          (k = (y = e.toast).onAutoClose) == null || k.call(y, e.toast), P();
        }, Y.value);
      };
      e.expanded || e.interacting ? n() : T(), o(() => {
        clearTimeout(i);
      });
    }), Z(() => {
      if (d.value) {
        const o = d.value.getBoundingClientRect().height;
        G.value = o, e.setHeights([{ toastId: e.toast.id, height: o }, ...e.heights]);
      }
    }), ae(() => {
      d.value && e.setHeights(
        e.heights.filter((o) => o.toastId !== e.toast.id)
      );
    }), R(() => {
      e.toast.delete && P();
    }), (o, i) => (u(), f("li", {
      "aria-live": t.toast.important ? "assertive" : "polite",
      "aria-atomic": "",
      role: "status",
      tabindex: "0",
      ref_key: "toastRef",
      ref: d,
      "data-sonner-toast": "",
      class: oe(r(_)),
      "data-styled": !r(X),
      "data-mounted": D.value,
      "data-promise": Boolean(t.toast.promise),
      "data-removed": g.value,
      "data-visible": r(h),
      "data-y-position": r(J)[0],
      "data-x-position": r(J)[1],
      "data-index": e.index,
      "data-front": r(l),
      "data-swiping": B.value,
      "data-type": v.value !== "loading" && v.value ? v.value : r(x),
      "data-invert": r(ue),
      "data-swipe-out": S.value,
      "data-expanded": Boolean(e.expanded || e.expandByDefault && D.value),
      style: ee({
        "--index": e.index,
        "--toasts-before": e.index,
        "--z-index": t.toasts.length - e.index,
        "--offset": `${g.value ? q.value : U.value}px`,
        "--initial-height": e.expandByDefault ? "auto" : `${G.value}px`,
        ...r(E)
      }),
      onPointerdown: ve,
      onPointerup: fe,
      onPointermove: me
    }, [
      e.closeButton && !r(X) ? (u(), f("button", {
        key: 0,
        "aria-label": "Close toast",
        "data-disabled": r(Q),
        "data-close-button": "",
        onClick: de
      }, [
        ye(Ve)
      ], 8, Ke)) : w("v-if", !0),
      r(x) || t.toast.icon || t.toast.promise ? (u(), f("div", We, [
        typeof t.toast.promise == "function" ? (u(), L($e, {
          key: 0,
          visible: v.value === "loading"
        }, null, 8, ["visible"])) : w("v-if", !0),
        r(se) === "success" ? (u(), L(Se, { key: 1 })) : w("v-if", !0),
        r(se) === "error" ? (u(), L(Ae, { key: 2 })) : w("v-if", !0)
      ])) : w("v-if", !0),
      C("div", Ye, [
        C("div", Je, [
          typeof t.toast.title == "string" ? (u(), f(z, { key: 0 }, [
            ie(F(t.toast.title), 1)
          ], 64)) : t.toast.title === void 0 || t.toast.title === null ? (u(), f(z, { key: 1 }, [
            ie(F(r(ce)), 1)
          ], 64)) : r(X) ? (u(), L(ge(t.toast.title), {
            key: 2,
            onCloseToast: i[0] || (i[0] = () => {
              var n;
              P(), (n = t.toast.cancel) != null && n.onClick && t.toast.cancel.onClick();
            })
          }, null, 32)) : w("v-if", !0)
        ]),
        t.toast.description ? (u(), f("div", {
          key: 0,
          "data-description": "",
          class: oe(t.descriptionClass + r(I))
        }, F(t.toast.description), 3)) : w("v-if", !0)
      ]),
      t.toast.cancel ? (u(), f("button", {
        key: 2,
        "data-button": "",
        "data-cancel": "",
        onClick: i[1] || (i[1] = () => {
          var n;
          P(), (n = t.toast.cancel) != null && n.onClick && t.toast.cancel.onClick();
        })
      }, F(t.toast.cancel.label), 1)) : w("v-if", !0),
      t.toast.action ? (u(), f("button", {
        key: 3,
        "data-button": "",
        onClick: i[2] || (i[2] = () => {
          var n;
          P(), (n = t.toast.action) == null || n.onClick();
        })
      }, F(t.toast.action.label), 1)) : w("v-if", !0)
    ], 46, je));
  }
});
const Xe = /* @__PURE__ */ A(Qe, [["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/Toast.vue"]]), Ze = ["aria-label"], et = ["data-theme", "data-rich-colors", "data-y-position", "data-x-position"], tt = j({
  inheritAttrs: !1
}), st = /* @__PURE__ */ j({
  ...tt,
  __name: "Toaster",
  props: {
    invert: Boolean,
    theme: {
      type: String,
      required: !1,
      default: "light"
    },
    position: {
      type: String,
      required: !1,
      default: "bottom-right"
    },
    hotkey: {
      type: Array,
      required: !1,
      default: ["altKey", "KeyT"]
    },
    richColors: Boolean,
    expand: Boolean,
    duration: Number,
    visibleToasts: {
      type: Number,
      required: !1,
      default: () => 3
    },
    closeButton: Boolean,
    toastOptions: {
      type: Object,
      required: !1
    },
    offset: [String, Number]
  },
  setup(t) {
    const e = t, s = "32px", a = 356, N = 14, K = be(), m = c([]), D = c([]), g = c(!1), B = c(!1), S = p(() => e.position.split("-")), v = c(null), q = e.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function G(d) {
      D.value = d;
    }
    function O(d) {
      m.value = m.value.filter(({ id: l }) => l !== d.id);
    }
    return Z(() => {
      const d = $.subscribe((l) => {
        if (l.dismiss) {
          m.value = m.value.map(
            (h) => h.id === l.id ? { ...h, delete: !0 } : h
          );
          return;
        }
        m.value = [l, ...m.value];
      });
      ae(() => {
        d();
      });
    }), R(() => {
      m.value.length <= 1 && (g.value = !1);
    }), R((d) => {
      function l(h) {
        var _, I;
        e.hotkey.every(
          (E) => h[E] || h.code === E
        ) && (g.value = !0, (_ = v.value) == null || _.focus()), h.code === "Escape" && (document.activeElement === v.value || ((I = v.value) == null ? void 0 : I.contains(document.activeElement))) && (g.value = !1);
      }
      document.addEventListener("keydown", l), d(() => {
        document.removeEventListener("keydown", l);
      });
    }), (d, l) => {
      var h;
      return u(), f(z, null, [
        w(" Remove item from normal navigation flow, only available via hotkey "),
        C("section", {
          "aria-label": `Notifications ${r(q)}`,
          tabIndex: -1
        }, [
          C("ol", {
            ref_key: "listRef",
            ref: v,
            tabIndex: -1,
            "data-sonner-toaster": "",
            "data-theme": t.theme,
            "data-rich-colors": t.richColors,
            "data-y-position": r(S)[0],
            "data-x-position": r(S)[1],
            style: ee(
              {
                "--front-toast-height": `${(h = D.value[0]) == null ? void 0 : h.height}px`,
                "--offset": typeof t.offset == "number" ? `${t.offset}px` : t.offset || s,
                "--width": `${a}px`,
                "--gap": `${N}px`,
                ...r(K).style
              }
            ),
            onMouseenter: l[0] || (l[0] = (x) => g.value = !0),
            onMousemove: l[1] || (l[1] = (x) => g.value = !0),
            onMouseleave: l[2] || (l[2] = () => {
              B.value || (g.value = !1);
            }),
            onPointerdown: l[3] || (l[3] = (x) => B.value = !1),
            onPointerup: l[4] || (l[4] = (x) => B.value = !1)
          }, [
            (u(!0), f(z, null, ne(m.value, (x, _) => {
              var I, E, M;
              return u(), L(Xe, {
                key: x.id,
                index: _,
                toast: x,
                duration: t.duration,
                className: (I = t.toastOptions) == null ? void 0 : I.className,
                descriptionClassName: (E = t.toastOptions) == null ? void 0 : E.descriptionClassName,
                invert: t.invert,
                visibleToasts: t.visibleToasts,
                closeButton: t.closeButton,
                interacting: B.value,
                position: t.position,
                style: ee((M = t.toastOptions) == null ? void 0 : M.style),
                removeToast: O,
                toasts: m.value,
                heights: D.value,
                setHeights: G,
                expandByDefault: t.expand,
                expanded: g.value
              }, null, 8, ["index", "toast", "duration", "className", "descriptionClassName", "invert", "visibleToasts", "closeButton", "interacting", "position", "style", "toasts", "heights", "expandByDefault", "expanded"]);
            }), 128))
          ], 44, et)
        ], 8, Ze)
      ], 2112);
    };
  }
}), ot = /* @__PURE__ */ A(st, [["__file", "/Users/xiaoyunwei/Documents/GitHub/private/vue-sonner/packages/Toaster.vue"]]), lt = {
  install(t) {
    t.component("Toaster", ot);
  }
};
export {
  ot as Toaster,
  lt as default,
  rt as toast
};
